/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerOptionDto } from '../models/CustomerOptionDto';
import type { Wealthlane_CustomerSuccessVo_CustomerRoleOptionDto } from '../models/Wealthlane_CustomerSuccessVo_CustomerRoleOptionDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomerSuccessOptionsAppserviceService {

    /**
     * @returns CustomerOptionDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerCustomerSuccessOptionsMyCompanies(): CancelablePromise<Array<CustomerOptionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer/customer-success/options/my-companies',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns CustomerOptionDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerCustomerSuccessOptionsAllowedDestinationCompanies(): CancelablePromise<Array<CustomerOptionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer/customer-success/options/allowed-destination-companies',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns CustomerOptionDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerCustomerSuccessOptionsAllowedSourceCompanies(): CancelablePromise<Array<CustomerOptionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer/customer-success/options/allowed-source-companies',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns CustomerOptionDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerCustomerSuccessOptionsRoleMapping(): CancelablePromise<Array<CustomerOptionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer/customer-success-options/role-mapping',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sourceCompanyId
     * @returns Wealthlane_CustomerSuccessVo_CustomerRoleOptionDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerCustomerSuccessOptionsRolesPublished(
        sourceCompanyId: string,
    ): CancelablePromise<Array<Wealthlane_CustomerSuccessVo_CustomerRoleOptionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer/customer-success/options/roles/{sourceCompanyId}/published',
            path: {
                'sourceCompanyId': sourceCompanyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param q
     * @returns Wealthlane_CustomerSuccessVo_CustomerRoleOptionDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerCustomerSuccessOptionsSelfRoles(
        q?: string,
    ): CancelablePromise<Array<Wealthlane_CustomerSuccessVo_CustomerRoleOptionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer/customer-success/options/self-roles',
            query: {
                'q': q,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
